import RsrcTriggerHandler from "./RsrcTriggerHandler.js";
export default {
  install(plg) {
    plg.addPlugin('QueryTriggerHandler', {
      id: 'rsrc.RsrcTriggerHandler',
      matches: {
        objectType: 'rsrc'
      },
      handler: RsrcTriggerHandler
    });
  }
};